export default {
  title: 'Proveedores de entrega',
};
